// ==================== BADGE COMPONENT ====================

import type { ReactNode } from 'react';
import { cn } from '../../utils/helpers';

export interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'orange' | 'success' | 'error' | 'warning' | 'info';
  size?: 'sm' | 'md';
  className?: string;
}

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  className,
}: BadgeProps) => {
  const baseStyles = `
    inline-flex items-center justify-center
    font-semibold uppercase tracking-wider
    rounded-full
  `;

  const variants = {
    default: `
      bg-(--color-navy-light)
      text-(--color-soft-gray)
      border border-(--color-border-gray)
    `,
    orange: `
      bg-(--color-orange-glow)
      text-(--color-signal-orange)
      border border-[rgba(230,142,55,0.3)]
    `,
    success: `
      bg-(--color-success-light)
      text-(--color-success)
    `,
    error: `
      bg-(--color-error-light)
      text-(--color-error)
    `,
    warning: `
      bg-(--color-warning-light)
      text-(--color-warning)
    `,
    info: `
      bg-(--color-info-light)
      text-(--color-info)
    `,
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-3 py-1 text-xs',
  };

  return (
    <span className={cn(baseStyles, variants[variant], sizes[size], className)}>
      {children}
    </span>
  );
};

export { Badge };

